<form class="mb-2 h-full flex flex-column justify-content-between" #ajoutOperationDialog="ngForm">
	<div class="p-fluid formgrid grid">

		<!-- Submit -->
		<div class="field col-12">
			<button
				*ngIf="!readonly"
				type="button"
				pButton
				class="label-md-none mr-2"
				[label]="(isCreation ? 'common.add_button_label' : 'common.modify_button_label') | translate"
				[disabled]="
					readonly
					|| (!isCreation && simpleComparison(operation, initialOperation))
					|| !ajoutOperationDialog.form.valid || !operation.txt_id_cible || (operation.tot_code != 'ajo' && !operation.art_id_cible)"
				(click)="submit()"
			></button>
			<button
				type="button"
				pButton
				class="p-button-secondary"
				[label]="'common.exit_button_label' | translate"
				(click)="cancel()"
			></button>
		</div>

		<!-- Type d'opération -->
		<div class="field col-4 mb-1">
			<label>
				{{'textes.operation_type_label' | translate}}
			</label>
			<operation-selector
				name="tot_code"
				[(ngModel)]="operation.tot_code"
				(ngModelChange)="typeChange()"
				styleClass="w-full"
				[required]="true"
				[readonly]="!isCreation"
			></operation-selector>
		</div>

		<!-- Date application -->
		<div class="field col-12 md:col-6 xl:col-3 mb-1">
			<label for="txt_date_application">
				{{ 'textes.application_date_label' | translate }}
			</label>

			<p-calendar
				name="txt_date_application"
				appendTo="body"
				[(ngModel)]="operation.otm_date_application"
				[firstDayOfWeek]="1"
				dateFormat="dd/mm/yy"
				view="date"
				yearRange="1900:2100"
				[minDate]="
					isCreation ? tomorrow 
					: (operation.otm_date_execution ? null : operation.otm_date_application)"
				[showIcon]="!readonly"
				[readonlyInput]="readonly"
				placeholder="{{'textes.application_date_label' | translate}}"
				[required]="true"
			></p-calendar>
		</div>

		<!-- Date d'exécution -->
		<div class="field col-12 md:col-6 xl:col-3 mb-1">
			<label for="txt_date_application">
				{{ 'textes.execution_date_label' | translate }}
			</label>

			<input
				type="text"
				pInputText
				[attr.value]="
					operation.otm_date_execution ? 
					(operation.otm_date_execution | date:'shortDate') 
					: ('textes.not_executed_yet' | translate)"
				[readonly]="true"
			>
		</div>

		<!-- Texte ciblé -->
		<p-divider class="col-12 m-2" align="left">
			<b>{{ 'textes.target_texte' | translate }}</b>
		</p-divider>

		<!-- Sélection texte ciblé -->
		<ng-container *ngIf="isCreation  || (!readonly && !targetTexte)">
			<!-- Liste textes avec texte ciblé -->
			<div class="field col-12 md:col-6 mb-1">
				<label>
					{{ 'textes.target_texte' | translate }}
				</label>

				<div class="w-full md:col-6 flex flex-column overflow-auto h-15rem border-1 border-gray-100">
					<span *ngIf="textesLoading">{{'common.loading' | translate}}</span>
					<span *ngIf="!textesLoading && suggestedTextes.length == 0 && !nomenclatureFilter && !search_reference" class="text-color-danger">
						{{'textes.please_select_nomenclature_elem_or_search_texte' | translate}}
					</span>

					<ng-container *ngFor="let texte of suggestedTextes; index as i">
						<div 
							class="flex-none pl-1 pb-1 pt-1 cursor-pointer min-h-2rem flex flex-row align-items-center"
							[ngClass]="{'border-top-1 border-gray-100': i > 0}"
							(click)="setTargetTexte(texte.txt_id)"
							[title]="texte.txt_reference"
						>
							<div class="targetable-text-hover" [ngClass]="{'targeted-text font-bold': operation.txt_id_cible == texte.txt_id}"
							> 
								<span>{{texte.txt_reference}}</span>
								<br/>
								<div class="mt-1">{{suggestedTextesIntitules[i]}}</div>
							</div>
						</div>
					</ng-container>
				</div>	
			</div>

			<div class="field col-12 md:col-6 flex flex-column">
				<!-- Filtre de nomenclature -->
				<div class="field">
					<label for="nomenclature">
						{{ 'nomenclature.filter_label' | translate }}
					</label>

					<nomenclature-selector
						name="nomenclature"
						class="block w-full"
						[(ngModel)]="nomenclatureFilter"
						placeholder="{{'common.selector_placeholder' | translate}}"
						(onSelectionChange)="fetchSuggestedTextes()"
						[treeSelect]="true"
					></nomenclature-selector>
				</div>
				
				<!-- Recherche par référence -->
				<div
					class="field"
					pTooltip="{{'textes.reference_search_tooltip' | translate}}"
					tooltipStyleClass="max-w-30rem" showDelay="500" tooltipPosition="top"
				>
					<label for="search_reference">{{'textes.reference_search_label'|translate}}</label>
					<div class="p-inputgroup">
						<input
							pInputText
							type="text"
							name="search_reference"
							[(ngModel)]="search_reference"
							(onDebounce)="fetchSuggestedTextes()"
							[attr.placeholder]="'common.search_input_placeholder' | translate"
						/>
						<button type="button" class="p-inputgroup-addon" icon="pi pi-times" pButton label="" 
							[disabled]="!search_reference || textesLoading" 
							(click)="search_reference = null">
						</button>
					</div>
				</div>
			</div>
			
		</ng-container>

		<!-- Affichage texte ciblé -->
		<ng-container *ngIf="!isCreation  && targetTexte">
			<!-- Référence -->
			<div class="field col-12 md:col-6">
				<label for="reference">
					{{ 'textes.reference_label' | translate }}
				</label>

				<div>{{targetTexte.txt_reference}}</div>
			</div>

			<!-- Rubriques -->
			<div class="field col-12 mb-4">
				<label for="txt_edition">
					{{ 'textes.rubriques_label' | translate }}
				</label>

				<div class="rubriques-list expanded mb-2">

					<!-- Rubriques -->
					<p-card *ngFor="let rubrique of targetTexte.rubriques">
						<div class="flex flex-row align-items-center justify-content-between">
							<span>{{rubrique|nomenclature}}</span>
						</div>
					</p-card>

					<!-- Message si aucune rubrique -->
					<div *ngIf="targetTexte.rubriques.length == 0">
						{{ 'textes.texte_linked_to_no_rubrique' | translate }}
					</div>
				</div>
			</div>
		</ng-container>

		<!-- Article ciblé ou nouvel article -->
		<p-divider class="col-12 mt-4" align="left" *ngIf="targetTexte">
			<b>{{ 'textes.article_or_position' | translate }}</b>
		</p-divider>

		<!-- Sélection article/position ciblée -->
		<ng-container *ngIf="targetTexte" >
			<!-- Liste articles -->
			<div class="field col-12 md:col-6 xl:col-3" #subTargetList>
				<label>
					{{ (operation.tot_code == 'ajo' ? 'textes.target_position' : 'textes.target_article') | translate }}
				</label>

				<div class="w-full flex flex-column overflow-auto h-20rem border-1 border-gray-100">
					<!-- Sélection d'une position cible -->
					<ng-container *ngIf="operation.tot_code == 'ajo'">
						<div *ngFor="let article of targetTexte.articles" 
							class="flex-none flex flex-column"
						>
							<!-- Position-->
							<div class="h-1rem w-full bg-blue-100 targetable-position-hover" 
								[ngClass]="{'targeted-position': operation.art_id_position == article.art_id, 'cursor-pointer': !readonly}" 
								(click)="setTargetPosition(article.art_id)">
							</div>

							<!-- Titre de l'article -->
							<div class="min-h-2rem pl-1 flex flex-row align-items-center" [title]="article.art_titre"> 
								<span> {{article.art_titre}} </span>
							</div>
						</div>

						<!-- Dernière position, après tous les articles -->
						<div class="flex-none h-1rem w-full bg-blue-100 targetable-position-hover" 
							[ngClass]="{'targeted-position': operation.art_id_position === null, 'cursor-pointer': !readonly}" 
							(click)="setTargetPosition(null)">
						</div>
					</ng-container>

					<!-- Sélection d'un article cible -->
					<ng-container *ngIf="operation.tot_code != 'ajo'">
						<div *ngFor="let article of targetTexte.articles" 
							class="flex-none pl-1 border-top-1 border-gray-100 min-h-2rem flex flex-row align-items-center"
							(click)="setTargetArticle(article)"
							[title]="article.art_titre"
						>
							<span 
								class="targetable-article-hover" 
								[ngClass]="{'targeted-article font-bold': operation.art_id_cible == article.art_id, 'cursor-pointer': !readonly}" 
								
							>
								{{article.art_titre}}
							</span>
						</div>
					</ng-container>
				</div>	
			</div>
		</ng-container>

		<div class="col-12 md:col-6 xl:col-9 mb-2" *ngIf="operation.tot_code && operation.tot_code != 'abr' && targetTexte">
			<!-- Titre nouvel article -->
			<div class="field" *ngIf="operation.tot_code == 'ajo'">
				<label>
					{{ 'common.title_label' | translate }}
				</label>

				<input
					class="block w-full"
					type="text"
					pInputText
					name="art_titre"
					[(ngModel)]="operation.art_titre"
					[readOnly]="readonly"
					[placeholder]="'common.title_label' | translate"
					required
				/>
			</div>

			<!-- Nouveau corps d'article -->
			<div class="field">
				<label>
					{{ 'textes.body' | translate }}
				</label>

				<html-editor
					name="art_corps"
					id="art_corps-operation"
					[(ngModel)]="operation.art_corps"
					class="angular-editor-wrapper-min-400"
					[required]="true"
					[readonly]="readonly"
				></html-editor>
			</div>
		</div>
	</div>
</form>